import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import UnitPlanDetails from "./routes/UnitPlanDetails";
import UnitPlanCreate from "./routes/UnitPlanCreate";
import YearlyInsight from "YearlyInsight";
import CourseUnitPlansOverview from "./routes/CourseUnitPlansOverview";
import CourseUnitPlansTimelineTable from "./routes/CourseUnitPlansTimelineTable";
import CardView from "./routes/CardView";
import ACLStore from "lib/aclStore";

export default store => ({
  path: "unitPlans",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "unitPlans" */ "./components"),
        import(
          /* webpackChunkName: "unitPlans" */ "IBPlanner/modules/IBPlannerModule"
        ),
        import(
          /* webpackChunkName: "unitPlans" */ "./routes/CourseUnitPlansOverview/modules/Module"
        ),
        import(
          /* webpackChunkName: "unitPlans" */ "MultiLevelNodeEditor/modules/MultiLevelNodeEditorModule"
        ),
        import(
          /* webpackChunkName: "unitPlans" */ "SubjectsSetup/modules/SubjectsModule"
        ),
        import(
          /* webpackChunkName: "unitPlans" */ "Scheduler/modules/SchedulerModule"
        ),
        import(
          /* webpackChunkName: "unitPlans" */ "./routes/NewCourseUnitPlansOverview/modules/Module"
        ),
        import(
          /* webpackChunkName: "unitPlans" */ "./routes/NewCourseUnitPlansOverviewV2/modules/Module"
        ),
      ]).then(
        ([
          importedModule0,
          importedModule1,
          importedModule2,
          importedModule3,
          importedModule4,
          importedModule5,
          importedModule6,
          importedModule7,
        ]) => {
          const component = importedModule0.default;
          const plannerReducer = importedModule1.default;
          const courseOverviewReducer = importedModule2.default;
          const multiLevelNodeEditorReducer = importedModule3;
          const subjectSetupReducer = importedModule4.default;
          const schedulerReducer = importedModule5.default;
          const newCourseUnitPlansOverviewReducer = importedModule6.default;
          const newCourseUnitPlansV2OverviewReducer = importedModule7.default;
          injectReducer(store, {
            key: "planner",
            reducer: plannerReducer,
          });
          if (ACLStore.can("FeatureFlag:EnableNewUnitPlanFeed")) {
            injectReducer(store, {
              key: "courseOverview",
              reducer: newCourseUnitPlansV2OverviewReducer,
            });
          } else if (
            ACLStore.can("FeatureFlag:EnableNewCourseOverviewModals")
          ) {
            injectReducer(store, {
              key: "courseOverview",
              reducer: newCourseUnitPlansOverviewReducer,
            });
          } else {
            injectReducer(store, {
              key: "courseOverview",
              reducer: courseOverviewReducer,
            });
          }

          injectReducer(store, {
            key: "multiLevelNodeEditor",
            reducer: multiLevelNodeEditorReducer.default,
          });
          injectReducer(store, {
            key: "subjectsSetup",
            reducer: subjectSetupReducer,
          });
          injectReducer(store, {
            key: "scheduler",
            reducer: schedulerReducer,
          });
          return component;
        }
      )
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [
    CourseUnitPlansOverview(store),
    CourseUnitPlansTimelineTable(store),
    CardView(store),
    UnitPlanCreate(store),
    YearlyInsight(store),
    UnitPlanDetails(store),
  ],
});
